import React from 'react'
import { cn } from '~shared/utils/cn'

import { IconArrowRight } from './icons/IconArrowRight'
import Link from 'next/link'
import { getProgramData } from '~shared/api/single-program-data/single-program-data'

export const ProgramLicenseSection = ({
  program
}: {
  program: Awaited<ReturnType<typeof getProgramData>>
}) => {
  const doc = {
    id: 1,
    title: 'Государственная лицензия',
    img:
      program?.category?.slug === 'kursy'
        ? '/assets/imgs/docs/license.jpg'
        : '/assets/imgs/docs/licenseHigh.jpg',
    link:
      program?.category?.slug === 'kursy'
        ? 'https://islod.obrnadzor.gov.ru/rlic/details/e6d90a44-2d1c-3f1e-38cd-23b05043cdb7/'
        : ('https://islod.obrnadzor.gov.ru/rlic/details/0B100E0A-0A0B-110B-0D10-0E13110C0C111010110E/' as `http${string}`),
    bg: 'url(/assets/imgs/eagle.png) no-repeat bottom center #F6F6F6'
  }
  return (
    <>
      <section className=' py-[80px] text-black'>
        <div
          className={cn(
            'mx-auto px-[16px] box-border',
            'max-w-[672px]',
            'md:max-w-[832px]',
            '2lg:max-w-[1280px]'
          )}>
          <div
            style={{ background: doc?.bg }}
            className={cn(
              'mb-[24px] p-[16px] md:p-[24px] rounded-[24px] 2lg:rounded-[32px]  justify-between bg-cover',
              'md:h-[357px] md:flex',
              'lg:h-[500px]',
              'xl:h-[600px]'
            )}>
            <div className='flex flex-col justify-between mb-[24px] md:mb-0 2lg:p-[40px] gap-[16px]'>
              <h2 className='typo-section-heading-v2  xl:max-w-[500px] text-left'>
                {doc?.title}
              </h2>
              <Link
                href={doc?.link}
                target='_blank'
                className={cn(
                  'flex items-center justify-center text-[#6A6A6A] underline  max-w-full  gap-[34px]',
                  'lg:text-[20px]/[120%] lg:max-w-[450px]',
                  'xl:max-w-[500px]'
                )}>
                Проверьте лицензию на сайте Федеральной службы по надзору в
                сфере образования и науки
                <IconArrowRight className='min-h-[40px] max-h-[40px] min-w-[40px] rounded-full xl:min-w-[68px] xl:min-h-[68px]  bg-accent hover:bg-black transition-colors' />
              </Link>
            </div>
            <img
              src={doc?.img ?? ''}
              alt={doc?.title}
              className='h-full w-fit rounded-[16px]'
            />
          </div>
        </div>
      </section>
    </>
  )
}
